export default {
  selectSize: 'Veuillez sélectionner la spécification complète',
  inventory: 'Inventaire',
  num: 'Quantité',
  nimNumTips: "Quantité minimum d'achat : {num}",
  addCart: 'Ajouter au panier',
  nowBuy: 'Acheter maintenant',
  remark: 'Laisser un message',
  goShop: 'ENTRER DANS LA BOUTIQUE',
  productTotalPrice: 'Le prix total du produit',
  productDetail: 'Détails du produit',
  sizeParams: 'Paramètres de spécification',
  shopNotes: "Notes de l'agent d'achat",
  saleService: 'Service après-vente',
  productInfo: 'Informations sur le produit',
  buyTips:
    'Les commandes payées entre 09h00 et 18h00 (heure de Pékin) seront traitées dans les 6 heures (sauf le dimanche).',
  buyer: 'Vendeur',
  selfWarehouse: 'Entrepôt désigné Acbuy',
  warehouse: 'Entrepôt désigné Acbuy',
  yourAddress: 'Votre adresse',
  calcCountryFreight: "Estimer les frais d'expédition internationaux",
  holder: {
    remarkHolder:
      "Si vous avez d'autres besoins, veuillez laisser un message dans les remarques, l'agent vous aidera pour la demande.",
  },
  supportPayment: 'Méthodes de paiement disponibles',
  disclaimer:
    "Tous les produits disponibles pour le service d'agent d'achat affichés sur acbuy proviennent de plateformes d'achat tierces et ne sont pas directement vendus par acbuy. Ainsi, acbuy n'assume aucune responsabilité juridique pour les problèmes causés par la violation des droits de propriété intellectuelle et la violation du droit d'auteur des marchandises.",
  readAgree: "J'ai lu et accepté ce qui précède",
  selectAgree: 'Clause de non-responsabilité non acceptée',
  copyLink: 'Copier le lien',
  copySuccess: 'Copie réussie',
  disclaimer1: 'Clause de non-responsabilité',
  editPrice: 'Modifier le prix',
  editPriceTips:
    "Veuillez noter qu'il y a un problème avec l'échange de coupons. Nous recommandons à l'utilisateur de modifier le prix de vente de l'article au prix d'origine.",
  editPriceEnum: {
    0: "Réduction sur l'expédition",
    1: 'Erreur de prix sur le site web',
    2: 'Négocié avec le vendeur',
    3: 'Autre raison',
  },
  imgTranslation: "Traduction d'image",
  translationTips: "Cliquez sur l'image pour traduire le texte",
  originTranslation: 'Original/Traduction',
  qcImg: 'Photo QC',
  deleteShopCollect: 'Êtes-vous sûr de vouloir supprimer la collection de cette boutique ?',
  inTransition: 'En transition...',
  originLink: 'Lien original',
  singleProductData: 'Données du produit unique',
}
